module.exports = [{
      plugin: require('../../../shopify_kit_templates/411baafe-e7da-49ff-81a7-7c5130d3e828/node_modules/gatsby-plugin-offline/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../shopify_kit_templates/411baafe-e7da-49ff-81a7-7c5130d3e828/node_modules/gatsby-theme-inflowkit-v2/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../shopify_kit_templates/411baafe-e7da-49ff-81a7-7c5130d3e828/node_modules/gatsby-plugin-web-font-loader/gatsby-browser.js'),
      options: {"plugins":[],"custom":{"families":[""],"urls":["/a/courses/full_college_admissions_roadmap/fonts.css"]}},
    },{
      plugin: require('../../../shopify_kit_templates/411baafe-e7da-49ff-81a7-7c5130d3e828/node_modules/gatsby-plugin-nprogress/gatsby-browser.js'),
      options: {"plugins":[],"color":"tomato","showSpinner":false},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../../shopify_kit_templates/411baafe-e7da-49ff-81a7-7c5130d3e828/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
